import { useSession } from '@side/next-auth/react';
import type { UserInformation } from '../../types/user';
import { getUserInformation } from '../../utils/user';
import { useUserInformation } from '../useUserInformation/useUserInformation';

export const useMyInformation = (): UserInformation | undefined => {
  const sessionUserData = useSession()?.data?.user;

  const fetchedUserData = useUserInformation(sessionUserData?.id);

  if (fetchedUserData) {
    return fetchedUserData;
  }

  if (sessionUserData) {
    return getUserInformation(sessionUserData);
  }

  return undefined;
};
